/**
 * 主页基本信息
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { connect } from 'react-redux';
import { Popover, Tabs, Modal, message, Badge } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Scrollbar from 'react-scrollbars-custom';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import IframeMiniModal from '../../../components/iframModal/IframMiniModal';
import MaxWill from '../maxWill/maxWill';
import WebglVideo from '../../webglVideo/indexNew';
import AffinityMsg from '../../affinityModal/AffinityMsg';
import InterestAffinity from '../../affinityModal/InterestAffinity';
import InterestAffinityCard from '../../affinityModal/components/InterestAffinityCard';
import IntimateAffinityCard from '../../affinityModal/components/IntimateAffinityCard';
import {
  _anly_seng_custom,
  _change_affinity_modal,
  _get_user_affinity_info,
  _get_user_info,
} from '../../../store/Action';
import { DDEmpty } from '../../globalPageStatus';
import './DsUserBasicInfo.scss';

class DsUserBasicInfo extends PureComponent {
  state = {
    ds: null, // 用户信息
    selectWallPic: null, // 选中的照片
    dsWallPicList: [], // 照片
    isShowSkill: false,
    isVideoPlaying: false, // 是否正在播放视频
    tab: 1,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.ds?.uid !== this.props.ds?.uid) {
      this.withData(this.props.ds);
    }
  }

  componentDidMount() {
    this.withData(this.props.ds);
  }

  componentWillUnmount() {
    this.destroyPlay();
  }

  // 整理数据
  withData = async (ds) => {
    // 照片展示
    const dsWallPicList = [];
    let index = 0;
    if (ds?.videoPic && ds?.videoUrl) {
      dsWallPicList.push({
        icon: ds.videoPic,
        url: ds.videoUrl,
        type: 2,
      });
    }
    if (ds?.headPic) {
      dsWallPicList.push({
        icon: ds.headPic,
        url: ds.headPic,
        type: 1,
        index: index++,
      });
    }
    if (ds?.wallPic?.length) {
      dsWallPicList.push(
        ...ds.wallPic.map((item) => ({
          icon: item,
          url: item,
          type: 1,
          index: index++,
        }))
      );
    }
    this.setState({
      ds,
      selectWallPic: dsWallPicList?.length ? dsWallPicList[0] : null,
      dsWallPicList,
    });

    // 主页特效，循环播放
    if (ds?.homePageEffect?.indexOf('.svga') > -1) {
      this.svgaIndexPlayer = new window.SVGA.Player(
        '#ds-index-effects-content'
      );
      this.svgaIndexParser = new window.SVGA.Parser(
        '#ds-index-effects-content'
      );
      this.svgaIndexParser.load(
        Util.transImgUrl(ds.homePageEffect),
        (videoItem) => {
          this.svgaIndexPlayer.loops = 0; // 循环播放
          this.svgaIndexPlayer.setVideoItem(videoItem);
          this.svgaIndexPlayer.startAnimation();
          this.svgaIndexPlayer.clearsAfterStop = true;
        }
      );
    } else if (ds?.homePageEffect?.indexOf('.mp4') > -1) {
      const dom = document.querySelector('#ds-index-effects-content');
      this.webglIndexPlayer = await WebglVideo({
        container: dom,
        src: Util.transImgUrl(ds.homePageEffect),
        loop: true,
      });
    }
    // 座驾特效，播放一遍
    if (ds?.carShowLevel) {
      if (ds?.carShowEffect?.indexOf('.svga') > -1) {
        const userShowCar = {
          text: `${ds.nickName}`,
          color: '#fff',
          family: 'Noto Sans SC',
          size: '18px',
          offset: { x: -0.0, y: 3.0 },
        };

        this.svgaCarPlayer = new window.SVGA.Player('#ds-car-effects-content');
        this.svgaCarParser = new window.SVGA.Parser('#ds-car-effects-content');
        this.svgaCarParser.load(
          Util.transImgUrl(ds.carShowEffect),
          (videoItem) => {
            this.svgaCarPlayer.loops = 1; // 循环播放
            this.svgaCarPlayer.setText(userShowCar, 'wenzi_kong1440');
            this.svgaCarPlayer.setVideoItem(videoItem);
            this.svgaCarPlayer.startAnimation();
            this.svgaCarPlayer.clearsAfterStop = true;
          }
        );
      } else if (ds?.carShowEffect?.indexOf('.mp4') > -1) {
        const dom = document.querySelector('#ds-car-effects-content');
        this.webglCarPlayer = await WebglVideo({
          container: dom,
          src: Util.transImgUrl(ds.carShowEffect),
          effects: {
            dingwei: {
              text: `${ds.nickName}`,
              fontStyle: `16px Noto Sans SC`,
              fontColor: '#666666',
            },
          },
        });
      }
    }
  };

  // 照片切换
  changeWallTab = (index) => {
    const { dsWallPicList } = this.state;
    const curWallPic = dsWallPicList[index];
    this.onVideoEnd();
    this.setState({ selectWallPic: curWallPic });
  };

  // 展示隐藏更多技能
  changeShowSkills = (visible) => {
    this.setState({ isShowSkill: visible });
  };

  //打开放大照片墙
  openWill = () => {
    const { dsWallPicList, selectWallPic } = this.state;
    const wallList = [];
    dsWallPicList.forEach((item) => {
      if (item.type === 1) {
        wallList.push(item.url);
      }
    });

    this.maxWillElement.showModal(
      wallList,
      selectWallPic ? selectWallPic.index : 0
    );
  };
  openInterestAffinity = (e, data) => {
    e.stopPropagation();
    if (data) {
      const { searchUid, otherUid } = data;
      _change_affinity_modal({
        interestAffinityDetailModal: true,
        interestAffinityDetailData: { searchUid, otherUid },
      });
    } else {
      const { ds } = this.state;
      this.interestAffinityElement.showModal(ds.uid);
    }
  };
  //播放视频
  videoPlay = () => {
    if (this.myVideo) {
      this.myVideo
        .play()
        .then(() => {
          this.setState({ isVideoPlaying: true });
        })
        .catch((err) => {
          this.setState({ isVideoPlaying: false });
        });
    }
  };
  //播放结束
  onVideoEnd = () => {
    this.setState({ isVideoPlaying: false });
  };
  //播放操作
  onVideoClick = () => {
    if (this.myVideo.paused) {
      this.videoPlay();
    } else {
      this.myVideo.pause();
      this.setState({ isVideoPlaying: false });
    }
  };

  // 销毁播放
  destroyPlay = () => {
    // 销毁主页特效SVGA
    if (this.svgaIndexPlayer) {
      this.svgaIndexPlayer.stopAnimation();
      this.svgaIndexPlayer.clear();
      this.svgaIndexPlayer.clearDynamicObjects();
    }
    // 销毁座驾SVGA
    if (this.svgaCarPlayer) {
      this.svgaCarPlayer.stopAnimation();
      this.svgaCarPlayer.clear();
      this.svgaCarPlayer.clearDynamicObjects();
    }
    // 销毁座驾WEBGL
    if (this.webglIndexPlayer) {
      this.webglIndexPlayer.stop();
    }
    // 销毁座驾WEBGL
    if (this.webglCarPlayer) {
      this.webglCarPlayer.stop();
    }
  };

  // 展示所有技能
  renderUserAllSkill = () => {
    const { isShowSkill, ds } = this.state;
    const userSkillCardList = ds?.userSkillCardList ?? null;
    const render = () => (
      <div className=" more-skills">
        <div
          className="icon-close"
          onClick={() => this.changeShowSkills(false)}
        >
          <CloseOutlined />
        </div>
        <div className="child-skill-list">
          {userSkillCardList.map((item) => (
            <div key={item.categoryId} className="skill-item-wrap">
              <div className="skill-cover">
                <img
                  src={Util.transImgUrl(item.icon, '60x60')}
                  alt={item.name}
                />
              </div>
              <div className="skill-info">
                <h4 className="skill-name">{item.name}</h4>
                {/* todo 2025.06.17 删除昵称展示 */}
                {/* <p className="skill-desc">昵称：{item.gameName}</p> */}
                <p className="skill-region">
                  {item.svr}/{item.level}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );

    return userSkillCardList?.length ? (
      <>
        <div className="child-sub-title">
          <span className="icon icon-2" />
          <h5>技能卡</h5>
        </div>
        <div className="child-skill-list">
          <div className="skill-item-wrap">
            <div className="skill-cover">
              <img
                src={Util.transImgUrl(userSkillCardList[0].icon, '60x60')}
                alt={userSkillCardList[0].name}
              />
            </div>
            <div className="skill-info">
              <h4 className="skill-name">{userSkillCardList[0].name}</h4>
              {/* todo 2025.06.17 删除昵称展示 */}
              {/* <p className="skill-desc">昵称：{userSkillCardList[0].gameName}</p> */}
              <p className="skill-region">
                {userSkillCardList[0].svr}/{userSkillCardList[0].level}
              </p>
            </div>
          </div>
          {ds.userSkillCardList.length > 1 ? (
            <Popover
              rootClassName="daidai-popover-default"
              trigger="click"
              open={isShowSkill}
              content={render()}
              onOpenChange={this.changeShowSkills}
            >
              <div
                className={Util.classNames('btn-skill-more', {
                  active: isShowSkill,
                })}
              >
                <i className="icon" />
                更多
              </div>
            </Popover>
          ) : null}
        </div>
      </>
    ) : null;
  };

  //切换亲密关系
  onTabChange = (tab) => {
    if (tab == 2) {
      const { ds } = this.state;
      _get_user_affinity_info({ searchUid: ds?.uid });
    }
    this.setState({ tab });
  };

  //邀请
  onInvite = () => {
    _change_affinity_modal({ affinityInviteModal: true });
  };

  // 查看亲密关系规则
  openRuleModal = (e) => {
    e.stopPropagation();
    const {
      base: { rootConfig },
    } = this.props;
    this.iframeMiniElement.showModal(
      `${rootConfig.mobilePath}/intimate-affinity-rules/index.html`,
      {
        width: 375,
        height: 740,
        isBorderRadius: false,
      }
    );
  };

  //解锁关系位
  unLockAffinity = (num, price) => {
    const { ds } = this.state;
    let content = (
      <p>
        需要消耗<span style={{ color: '#FF4279' }}>{price}钻石</span>解锁第
        {num + 1}个关系位
      </p>
    );
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      centered: true,
      className: 'daidai-confirm-style',
      content: content,
      okText: '立即解锁',
      cancelText: '我再想想',
      onOk: () => {
        HTTP._affinity_unlock_bit().then((res) => {
          if (res?.code === 200) {
            message.success('解锁成功');
            _get_user_info();
            _get_user_affinity_info({ searchUid: ds?.uid });
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };
  //邀请
  onIntive = () => {
    const { ds } = this.state;
    const { affinityData } = this.props.base;
    const {
      searchAnStatus,
      otherUid,
      searchUid,
      searchAnInviteOrderNo,
      searchAnIntimateRelationId: intimateRelationId,
      searchUidAnIntimate,
    } = ds?.intimateInfo;
    if (searchUidAnIntimate < affinityData.minValue) {
      message.warning('亲密值不够哦~');
      return;
    }
    // status 0:邀请中 10:已同意 20:已拒绝  30:已失效 40:待邀请
    if (searchAnStatus == 0) {
      _change_affinity_modal({
        affinityApplyModal: true,
        affinityApplyOtherUid: searchUid,
        affinityApplyOrderNo: searchAnInviteOrderNo,
      });
    } else if (searchAnStatus == 10) {
      _change_affinity_modal({
        affinitySpaceModal: true,
        affinitySpaceData: {
          otherUid,
          searchUid,
          intimateRelationId,
        },
      });
    } else {
      _change_affinity_modal({
        affinityDetailModal: true,
        affinityDetailOtherUid: searchUid,
      });
    }
  };

  openAffinitySpace = () => {
    const {
      relationCard: { otherUid, intimateRelationId },
    } = this.props;
    const { ds } = this.state;
    _change_affinity_modal({
      affinitySpaceModal: true,
      affinitySpaceData: { otherUid, searchUid: ds.uid, intimateRelationId },
    });
  };

  render() {
    const { base, relationCard } = this.props;
    const { affinityData } = base;
    const { ds, selectWallPic, dsWallPicList, isVideoPlaying, tab } =
      this.state;
    return (
      <div className="ds-user-basic-info">
        <Scrollbar className="my-scroll-bar">
          {selectWallPic && (
            <div className="basic-pic-wall">
              {selectWallPic.type === 2 && (
                <>
                  <video
                    className="video"
                    ref={(el) => (this.myVideo = el)}
                    onEnded={this.onVideoEnd}
                    onClick={this.onVideoClick}
                    poster={Util.transImgUrl(selectWallPic.icon, '400x400')}
                    src={`${base.rootConfig.baseVideoPath}${selectWallPic.url}`}
                  />
                  {!isVideoPlaying && (
                    <span className="play" onClick={this.videoPlay} />
                  )}
                </>
              )}
              <img
                src={Util.transImgUrl(selectWallPic.icon, '350x350')}
                alt={selectWallPic.index}
                onClick={this.openWill}
              />
              {relationCard?.otherUid ? (
                <div
                  className="relation-attr"
                  style={{
                    backgroundImage: `url(${Util.transImgUrl(relationCard?.relationConfig?.keepsakeWallIcon, '244x100')})`,
                  }}
                  onClick={this.openAffinitySpace}
                >
                  <div className="relation-token">
                    <img
                      src={Util.transImgUrl(
                        relationCard?.keepsakeWallResp?.staticPic,
                        '50x50'
                      )}
                      alt=""
                    />
                  </div>
                  <div className="reation-avatar">
                    <img
                      style={{
                        borderColor:
                          relationCard?.relationConfig?.relationConfigCardStyle,
                      }}
                      src={Util.transImgUrl(relationCard?.otherAvatar, '60x60')}
                      alt=""
                    />
                  </div>
                </div>
              ) : null}
            </div>
          )}
          {dsWallPicList?.length ? (
            <Tabs
              className="wall-pic-tab"
              onChange={this.changeWallTab}
              items={dsWallPicList.map((item, index) => ({
                key: index,
                label: (
                  <img src={Util.transImgUrl(item.icon, '36x36')} alt="" />
                ),
                children: null,
              }))}
            />
          ) : null}
          <div className="max-title-tab">
            <div
              className={`max-title-item basic-title ${tab == 1 ? 'active' : ''}`}
              onClick={() => this.onTabChange(1)}
            >
              {tab == 1 ? <div className="icon icon-1" /> : null}
              <h3 className="title">基本资料</h3>
            </div>
            <div
              className={`max-title-item basic-title ${tab == 2 ? 'active' : ''}`}
              onClick={() => this.onTabChange(2)}
            >
              {tab == 2 ? <div className="icon icon-2" /> : null}
              <h3 className="title">亲密关系</h3>
              <div className="icon icon-3" onClick={this.openRuleModal}></div>
            </div>
            {ds?.uid == base?.uid ? (
              <Badge
                className={`max-title-item apply-btn `}
                dot={affinityData?.redNewCount ? true : false}
                offset={[-4, 4]}
                onClick={() => this.affinityMsg.showModal()}
              >
                <span>关系申请</span> <i className="icon-arrow"></i>
              </Badge>
            ) : (
              <div
                className="max-title-item invite-btn"
                onClick={this.onIntive}
              >
                <i className="icon-lock"></i>
                <span>关系邀请</span>
              </div>
            )}
          </div>
          {tab == 1 ? (
            <div className="max-title-page">
              <div className="flex-line">
                <div className="user-const">
                  <div className="sub-title">
                    <i className="icon" />
                    星座
                  </div>
                  <p className="desc">{ds?.constellationName ?? '未知'}</p>
                </div>
                <div className="user-city">
                  <div className="sub-title">
                    <i className="icon" />
                    城市
                  </div>
                  <p className="desc">{ds?.city ?? '未知'}</p>
                </div>
              </div>

              <div className="child-sub-title">
                <span className="icon icon-1" />
                <h5>关于TA</h5>
              </div>
              <div className="child-content">
                {ds?.specificSign ?? '这个人很懒， 什么也没留下。'}
              </div>

              {/* 技能卡 */}
              {this.renderUserAllSkill()}

              <div className="child-sub-title">
                <span className="icon icon-3" />
                <h5>个性标签</h5>
              </div>
              <ul className="child-tag-list self-tag">
                {ds?.userLabelList?.length ? (
                  ds.userLabelList.map((item) => (
                    <li key={item.id} className="child-tag">
                      <span className="icon" />
                      <span>{item.labelName}</span>
                    </li>
                  ))
                ) : (
                  <span>暂无</span>
                )}
              </ul>

              <div className="child-sub-title">
                <span className="icon icon-6" />
                <h5>曲风标签</h5>
              </div>
              <ul className="child-tag-list like-game">
                {ds?.showLabelList?.length ? (
                  ds.showLabelList.map((item, index) => (
                    <li key={index} className="child-tag">
                      <span>{item}</span>
                    </li>
                  ))
                ) : (
                  <span>暂无</span>
                )}
              </ul>

              <div className="child-sub-title">
                <span className="icon icon-4" />
                <h5>喜欢的内容</h5>
              </div>
              <ul className="child-tag-list like-game">
                {ds?.gameLabelList?.length ? (
                  ds.gameLabelList.map((item) => (
                    <li key={item.id} className="child-tag">
                      <span>{item.labelName}</span>
                    </li>
                  ))
                ) : (
                  <span>暂无</span>
                )}
              </ul>

              <div className="child-sub-title">
                <span className="icon icon-5" />
                <h5>喜欢的声音</h5>
              </div>
              <ul className="child-tag-list like-sound">
                {ds?.soundList?.length ? (
                  ds.soundList.map((item) => (
                    <li key={item.id} className="child-tag">
                      <span>{item.labelName}</span>
                    </li>
                  ))
                ) : (
                  <span>暂无</span>
                )}
              </ul>
            </div>
          ) : (
            <div className="max-title-page">
              <div className="affinity-wrap">
                {affinityData?.funList?.length > 0 ? (
                  <div className="affinity-title">
                    <i className="affinity-icon icon-1"></i>
                    <span>趣味关系</span>
                    <i
                      className="affinity-icon icon-more"
                      onClick={(e) => this.openInterestAffinity(e)}
                    ></i>
                  </div>
                ) : null}
                <div className="interest-affinity-card">
                  {affinityData?.funList?.map((item) => (
                    <InterestAffinityCard
                      key={item.propConfigId}
                      data={item}
                      isTime={false}
                      isOpenDetail={true}
                    >
                      <div
                        className="interest-affinity-card-item-more"
                        onClick={(e) => this.openInterestAffinity(e, item)}
                      >
                        <span>趣味关系{item?.funNumber}</span>
                        <i className="icon-arrow"></i>
                      </div>
                    </InterestAffinityCard>
                  ))}
                </div>
                {affinityData?.intimateRelationList?.length > 0 ? (
                  <div className="affinity-title">
                    <i className="affinity-icon icon-2"></i>
                    <span>亲密关系</span>
                  </div>
                ) : null}
                <div className="intimate-affinity-box">
                  {affinityData?.intimateRelationList?.map((item) => (
                    <IntimateAffinityCard
                      key={item.intimateRelationId}
                      data={item}
                    />
                  ))}
                  {ds.uid == base.uid &&
                    new Array(
                      (affinityData?.totalIntimateNumber || 0) -
                        (affinityData?.useIntimateNumber || 0)
                    )
                      .fill('')
                      .map((_, index) => (
                        <div
                          className="intimate-affinity-item mini bg0"
                          key={index}
                        >
                          <div className="intimate-affinity-item-cover"></div>
                          <div className="intimate-affinity-item-name">
                            虚位以待
                          </div>
                          <div
                            className="intimate-affinity-item-invite"
                            onClick={this.onInvite}
                          >
                            邀请
                          </div>
                        </div>
                      ))}
                  {ds.uid == base.uid ? (
                    <div
                      className="intimate-affinity-item lock"
                      onClick={() =>
                        this.unLockAffinity(
                          affinityData?.totalIntimateNumber,
                          affinityData?.unLockCost
                        )
                      }
                    >
                      <div className="intimate-affinity-item-name">
                        <p>点击解锁</p>
                        <p>更多关系位</p>
                      </div>
                    </div>
                  ) : null}
                </div>
                {affinityData?.funList?.length == 0 &&
                affinityData?.intimateRelationList?.length == 0 &&
                ds.uid != base.uid ? (
                  <DDEmpty description="关系正在酝酿中…" />
                ) : null}
              </div>
            </div>
          )}
        </Scrollbar>
        {/* 照片墙 */}
        <MaxWill wrappedComponentRef={(el) => (this.maxWillElement = el)} />
        {/* 关系消息 */}
        <AffinityMsg wrappedComponentRef={(el) => (this.affinityMsg = el)} />
        {/* 趣味关系 */}
        <InterestAffinity
          wrappedComponentRef={(el) => (this.interestAffinityElement = el)}
        />
        {/* H5弹窗 */}
        <IframeMiniModal
          wrappedComponentRef={(el) => (this.iframeMiniElement = el)}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(DsUserBasicInfo, { withRef: true })
);
